// GENERATED FILE - DO NOT MODIFY

export enum ArticleTypeDto {
    News = "News",
    PressRelease = "PressRelease",
}